/** MY Contact Detail: 이름(CONTACT_NAME)만 수정 불가 */
export const MY_DETAIL_READONLY_FIELDS = ['CONTACT_NAME'] as const;

export function isMyDetailNameOnlyReadonlyField(
    fieldName: string,
    isMyDetailEditableExceptName: boolean,
): boolean {
    return isMyDetailEditableExceptName && fieldName === 'CONTACT_NAME';
}

export function resolveContactDetailFieldReadonly(
    fieldName: string,
    opts: {
        isMyDetailEditableExceptName: boolean;
        isBizFileRegistrant: boolean;
        propsReadonly: boolean;
        readonlyFields: string[];
    },
): boolean {
    if (isMyDetailNameOnlyReadonlyField(fieldName, opts.isMyDetailEditableExceptName)) {
        return true;
    }
    if (opts.isMyDetailEditableExceptName) {
        return false;
    }
    if (opts.isBizFileRegistrant) {
        return true;
    }
    return opts.propsReadonly || opts.readonlyFields.includes(fieldName);
}

export function resolveContactDetailFormReadonly(
    isMyDetailEditableExceptName: boolean,
    propsReadonly: boolean,
): boolean {
    if (isMyDetailEditableExceptName) {
        return false;
    }
    return propsReadonly;
}
